import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { settingsSections, useSettingsStore, type SettingsSection } from '@/stores/useSettingsStore'

export const Route = createFileRoute('/workspace/settings')({
  validateSearch: (search: Record<string, unknown>): { section?: SettingsSection; action?: 'topup' } => ({
    section: settingsSections.find((section) => section === search.section),
    action: search.action === 'topup' ? 'topup' : undefined,
  }),
  component: SettingsPage,
})

/**
 * Settings is now a global modal (SettingsModal in root layout).
 * If someone navigates directly to /workspace/settings, open the modal and go back.
 */
function SettingsPage() {
  const navigate = useNavigate()
  const open = useSettingsStore((s) => s.open)
  const { section, action } = Route.useSearch()

  useEffect(() => {
    open(section, { topUp: section === 'billing' && action === 'topup' })
    void navigate({ to: '/workspace/recents', replace: true })
  }, [open, navigate, section, action])

  return null
}
